import { AxiosResponse } from "axios";
import { GenericService } from "./Generic.service";

export interface PersonExamType {
  id: string;
  pessoaId: string;
  exameId: string;
  nomeExame: string;
  dataColeta: string;
  dataResultado: string;
  valor: string;
  unidade: string;
  formato: "Numerico" | "Texto";
}

export class PersonExamService extends GenericService<string> {
  readonly URI: string = "PessoaExameResultado";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async getExams({
    id,
    Nome,
    ...rest
  }: {
    id: string;
    Nome?: string;
    Ano?: string;
  }) {
    return await super.getByResource<AxiosResponse<PersonExamType[]>>(`${id}`, {
      PageSize: 500,
      Nome: Nome ? Nome : undefined,
      ...rest,
    });
  }

  public async getExamsCard(id: string) {
    return await super.getByResource(`${id}/Card`, {
      PageSize: 3,
    });
  }

  public async registerExamResult(body: any) {
    return await super.post(body)
  }

}
